// StepEase Theme JS
// Slider utility used across sections
function scrollSlider(id, amount) {
  var el = document.getElementById(id);
  if (el) el.scrollBy({ left: amount, behavior: 'smooth' });
}

// Auto-close announcement if needed
document.addEventListener('DOMContentLoaded', function() {
  // Cart count update
  var cartLinks = document.querySelectorAll('a[href="/cart"]');
});
